export default "__VITE_ASSET__BAtjhUkM__"